<template>
	<div>
		<v-row justify="center">
			<v-dialog v-model="dialog" persistent max-width="400">
				<v-card>
					<v-card-title class="text-h5">
						{{ $t("timeOfUseController") }}
					</v-card-title>
					<v-card-text>
						{{ $t("youUsedTheSiteFor") }} {{ this.$store.state.userTimeLimit }}
						{{ $t("doYouWantToContinueBrowsing") }}
					</v-card-text>
					<v-card-actions>
						<v-btn color="red darken-1 ml-2" text @click="getOut()">
							{{ $t("exit") }}
						</v-btn>
						<v-spacer></v-spacer>
						<v-btn color="blue darken-1 mr-2" text @click="stayBetting()">
							{{ $t("continue") }}
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-row>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				timePassed: 0,
				timerInterval: null,
				// dialog: false,
			};
		},

		computed: {
			TIME_LIMIT() {
				return Number(this.$store.state.userTimeLimit) * 60;
			},
			logged() {
				return this.$store.state.logged.status;
			},
			dialog() {
				return this.$store.state.dialogTimeActivity;
			},
			timeLeft() {
				if (!this.TIME_LIMIT) return;
				return this.TIME_LIMIT - this.timePassed;
			},

			timeFraction() {
				const rawTimeFraction = this.timeLeft / this.TIME_LIMIT;
				return rawTimeFraction - (1 / this.TIME_LIMIT) * (1 - rawTimeFraction);
			},
		},
		created() {
			this.$store.commit("showDialogTimeActivity", false);
		},

		watch: {
			timeLeft(newValue) {
				const local = localStorage.getItem("lastLogin");
				const now = Math.round(Date.now()) / 1000;
				const timeDiff = Math.round(now - Number(local));

				// Debug no console
				// console.log("TIME_LIMIT", this.TIME_LIMIT);
				// console.log("Progressiva", timeDiff);
				// console.log("Regressiva", newValue);
				if (this.TIME_LIMIT == "0") {
					this.$store.commit("showDialogTimeActivity", false);
					return;
				}

				if (
					newValue === 0 ||
					timeDiff >= this.TIME_LIMIT ||
					timeDiff > this.TIME_LIMIT
				) {
					this.onTimesUp();
					return;
				}
			},
			logged(val) {
				if (!val) {
					this.$store.commit("showDialogTimeActivity", false);
					return;
				}
				val && this.startTimer();
			},
		},

		mounted() {
			if (this.logged && this.timePassed == 0) {
				this.startTimer();
				return;
			}
		},

		methods: {
			onTimesUp() {
				clearInterval(this.timerInterval);
				this.$store.commit("showDialogTimeActivity", true);
			},

			startTimer() {
				this.timerInterval = setInterval(() => (this.timePassed += 1), 1000);
			},
			stayBetting() {
				localStorage.setItem("lastLogin", Math.round(Date.now() / 1000));
				this.timePassed = 0;
				this.startTimer();
				this.$store.commit("showDialogTimeActivity", false);
			},
			getOut() {
				this.$logout();
				localStorage.setItem("lastLogin", "");
				this.$store.commit("showDialogTimeActivity", false);
			},
		},
	};
</script>
